<div *ngIf="label" class="label mb-8px">{{ label }}<span *ngIf="isRequired" class="mandatory">*</span>
    <ng-content></ng-content>
</div>
<div #controlContainer class="control-container" [class.invalid]="hasErrors">
    <textarea #ref #input [class.d-none]="loading"> </textarea>
</div>
